import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Gateway } from 'react-gateway'

import { show } from 'store/reducers/modals'

import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import Link from 'components/Link'

import classes from './Header.scss'

export class Header extends React.Component {
  handleOpenModal = e => {
    e && e.preventDefault()
    this.props.dispatch(show('feedback'))
  };

  renderModalTrigger = () => {
    return <Gateway into='feedback'>
      <Button options={['purple', 'large', 'desktop']} callback={this.handleOpenModal}>
        Questions?
      </Button>
    </Gateway>
  };

  getLinks = filterFunction => {
    let links = [
      { name: 'Manage Pricelist', href: '/daily_products', location: 'admin' },
      { name: 'Fulfillment View', href: '/process', location: 'admin' },
      { name: 'Orders', href: '/orders/list', location: 'admin' },
      { name: 'Customers', href: '/customers', location: 'admin' },
      { name: 'Users', href: '/users', location: 'admin' },
      { name: 'Products', href: '/products', location: 'admin' },
      // { name: 'Recurring Orders', href: '/recurring_orders', location: 'admin' },
      { name: 'Routes', href: '/routes', location: 'admin' },
      { name: 'Categories', href: '/categories', location: 'admin' },
      { name: 'Types', href: '/types', location: 'admin' },
      { name: 'Uoms', href: '/uoms', location: 'admin' },
      { name: 'Specs', href: '/options', location: 'admin' },

      // not logged in *only*
      { name: 'Home', href: '/', location: 'right', isLoggedIn: false, desktop: false },
      { name: 'Pricelist', href: '/pricelist', location: 'right', isLoggedIn: false },
      { name: 'Contact Us', onClick: this.handleOpenModal, location: 'right', isLoggedIn: false, desktop: false },
      { name: 'Login', href: '/login', location: 'right', isLoggedIn: false },

      // logged in *only*
      { name: 'Home', href: '/', location: 'right', desktop: false },
      { name: 'My Orders', href: '/orders/list', location: 'right' },
      { name: 'Pricelist', href: '/pricelist', location: 'right' },
      { name: 'Account', href: '/account', location: 'right' },
      { name: 'Contact Us', onClick: this.handleOpenModal, location: 'right', desktop: false }
    ]

    if (filterFunction && typeof filterFunction === 'function') links = links.filter(filterFunction)

    // use isLoggedIn
    if (!this.props.isLoggedIn) links = links.filter(o => o.isLoggedIn === false)
    else if (this.props.isLoggedIn) links = links.filter(o => o.isLoggedIn === true || o.isLoggedIn === undefined)
    return links
  };

  renderAdminDropdown = () => {
    if (!this.props.isAdmin) return false

    return <Dropdown name='Admin' className={classes.dropdown} menuItems={this.getLinks(o => o.location === 'admin')} />
  };

  renderMobileDropdown = () => {
    return <Dropdown name='Navigate'
      className={classes.dropdown}
      mobileOnly
      mobileHamburger
      menuItems={this.getLinks(o => o.location === 'right' && o.mobile !== false)}
    />
  };

  renderDesktopLinks = () => {
    return this.getLinks(o => o.location === 'right' && o.desktop !== false).map((link, key) => {
      let props = {
        to: link.to,
        href: link.href,
        onClick: link.onClick,
        title: link.name,
        key: `nav-link-${key}`,
        className: classes['navigation__link']
      }

      return <Link {...props}>{link.name}</Link>
    })
  };

  render () {
    return <header className={classes.navigation}>
      <div className={classes['navigation__brand']}>
        <Link to='/' className={classes['navigation__logo']}>
          TwoXSea
        </Link>
        <small className={classes['navigation__city']}>San Francisco, CA</small>
      </div>

      <nav className={classes['navigation__right']}>
        {this.renderAdminDropdown()}
        {this.renderMobileDropdown()}

        {this.renderDesktopLinks()}
      </nav>

      {this.renderModalTrigger()}
    </header>
  }
}

Header.propTypes = {
  isLoggedIn: PropTypes.bool,
  isAdmin: PropTypes.bool,

  dispatch: PropTypes.func.isRequired
}

Header.defaultProps = {
  isLoggedIn: false,
  isAdmin: false
}

const mapStateToProps = (state, ownProps) => ({})
const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js